import React from "react";

const Button = ({ type, text, loading, onClick, disabled }) => {
  const isDisabled = loading || disabled;

  return (
    <button
      type={type}
      className="auth__form-button"
      onClick={onClick}
      disabled={isDisabled}
      style={{
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {loading ? <span className="auth__spinner"></span> : text}
    </button>
  );
};

export default Button;
